<template>
  <div>

    <div class="form-actions flex justify-between">
      <div class="flex vx-col-action">
        <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />
        
        <span class="br-line mr-2 ml-2"></span>
      </div>

      <div class="float-right flex">
        <vs-button class="iconOnly agreement-approve-icon" color="primary" type="flat" icon-pack="feather" icon="icon-check-circle" @click="approveAgreements()" :disabled="this.selectedRowCount == 0 || this.rejectedPromo || this.emptyList"></vs-button>
        <vs-button class="iconOnly agreement-reject-icon" color="danger" type="flat" icon-pack="feather" icon="icon-x-circle" @click="rejectAgreements()" :disabled="this.selectedRowCount == 0 || this.emptyList || this.rejectedPromo"></vs-button>
        <vs-button class="iconOnly agreement-reject-icon" color="danger" type="flat" icon-pack="feather" icon="icon-trash-2" @click="agreementBulkDeleteConfirm()" :disabled="this.selectedRowCount == 0"></vs-button>


        <span class="br-line-long mr-4 ml-4 h-60"></span>

        <vs-chip transparent closable color="primary" class="chip-selected-rows" @click="deselectAllSelectedRows()">
            {{ this.gridApi ? this.gridApi.getSelectedNodes().length : 0 }} Rows Selected
        </vs-chip>
        <vx-tooltip :text="!flags['selectedAll'][currentPage - 1] ? 'Select All' : 'Deselect All'" position="top">
            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" :icon="flags['selectedAll'][currentPage - 1] ? 'icon-check-square' : 'icon-square'" @click="toggleSelectAll()"></vs-button>
        </vx-tooltip>

        <span class="br-line-long mr-4 ml-4 h-60"></span>

        <vx-tooltip text="Download list" position="top">
            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
        </vx-tooltip>
        <vx-tooltip text="Reset Filters" position="top">
            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
        </vx-tooltip>
      </div>
    </div>
   
    <div>
      <div id="grid-loader" class="vx-card vs-con-loading__container">
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :components="components"
          :rowData="tableData"
          rowSelection="multiple"
          :enableRangeSelection="true"
          :suppressCopyRowsToClipboard="true"
          :suppressDragLeaveHidesColumns="true"
          :animateRows="false"
          :floatingFilter="true"
          :pagination="true"
          paginationAutoPageSize=true
          :suppressPaginationPanel="true"
          :suppressRowClickSelection="true"
          :rowClassRules="rowClassRules"
          :statusBar="statusBar"
          :sideBar="sideBar"
          :rowHeight="30"
          :headerHeight="30"
          :floatingFiltersHeight="35"
          :checkboxSelection="true"
          @filter-changed="onFilterChanged"
          @row-selected="onRowSelected"
          @pagination-changed="onPaginationChanged"
          @column-resized="onColumnResized">
        </ag-grid-vue>
        <div class="vx-row py-5">
          <div class="vx-col w-full">
            <vs-pagination
              :total="totalPages"
              :max="maxPageNumbers"
              class="custom-pagination"
              v-model="currentPage" />
          </div>
        </div>
      </div>
    </div>

    <vs-popup
      class="comments-popup"
      title="Reject Agreement Request"
      :active.sync="addRejectCommentPopup">
      <div
        id="div-with-modal-loading"
        class="div-with-agreement-modal-loading vs-con-loading__container">
        <div class="vx-row flex-wrap">
          <vs-table
            class="action-dash-table"
            :data="selectedAgreementForRejection">
            <template slot="thead">
              <vs-th class="pointer-events-none">Agreement Name</vs-th>
              <vs-th class="pointer-events-none">Type</vs-th>
              <vs-th class="pointer-events-none">Client</vs-th>
              <vs-th class="pointer-events-none">AM</vs-th>
              <vs-th class="pointer-events-none">Start Date</vs-th>
              <vs-th class="pointer-events-none">End Date</vs-th>
              <vs-th class="pointer-events-none">Upload Date</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    {{ data[indextr].filename }}
                  </div>
                </vs-td>
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    {{ data[indextr].type }}
                  </div>
                </vs-td>
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    <div v-if="data[indextr].unique_registrar_id">
                      {{ data[indextr].unique_registrar.name }}
                    </div>
                    <div v-else>
                      {{ data[indextr].new_reseller.name }}
                    </div>
                  </div>
                </vs-td>
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    <div
                      v-if="
                        data[indextr].unique_registrar_id &&
                        data[indextr].unique_registrar
                          .unique_registrar_client_am &&
                        data[indextr].unique_registrar
                          .unique_registrar_client_am[0].user
                      "
                    >
                      {{
                        data[indextr].unique_registrar
                          .unique_registrar_client_am[0].user.name
                      }}
                    </div>
                    <div v-else-if="data[indextr].new_reseller && data[indextr].new_reseller.new_reseller_client_am && data[indextr].new_reseller.new_reseller_client_am[0].user">
                      {{
                        data[indextr].new_reseller.new_reseller_client_am[0]
                          .user.name
                      }}
                    </div>
                  </div>
                </vs-td>
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    {{ data[indextr].start_date }}
                  </div>
                </vs-td>
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    {{ data[indextr].end_date }}
                  </div>
                </vs-td>
                <vs-td>
                  <div class="inline-block w-24 md:w-auto">
                    {{ data[indextr].updated_at }}
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="vx-col w-full mb-6 comment-wrap">
            <label class="mb-2 inline-block">Comments: </label>
            <vs-textarea
              placeholder="Write your comment here..."
              class="w-full"
              v-model="reject_comments" />
          </div>
        </div>
        <vs-button
          color="danger"
          type="filled"
          class="flex ml-auto mb-4 mr-4 action-btn"
          @click="submitRejection"
          :disabled="reject_comments == ''">
          Reject Agreement</vs-button>
      </div>
    </vs-popup>
    <!-- Edit Agreement component -->
    <UploadAgreement :agreementId="selectedAgreementId"></UploadAgreement>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererStatus from "@/components/ag-grid-tables/actions/CellRendererStatus.vue";
import CellRendererViewAndEditActions from "@/components/ag-grid-tables/actions/CellRendererViewAndEditActions.vue";
import CellRendererAgreementFile from '@/components/ag-grid-tables/actions/CellRendererAgreementFile.vue';
import UploadAgreement from "@/components/UploadAgreement.vue";

export default {
  name: "AgreementRequestComponent",
  components: {
    AgGridVue,
    CellRendererStatus,
    CellRendererViewAndEditActions,
    CellRendererAgreementFile,
    UploadAgreement,
  },
  data() {
    return {
      selectedRowCount: "",
      rejectedPromo: false,
      activePrompt: false,
      addRejectCommentPopup: false,
      selectedAgreementForRejection: [],
      reject_comments: "",
      autoGroupColumnDef: null,
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filterParams: {
          suppressAndOrCondition: true,
          newRowsAction: "keep",
        },
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      columnDefs: null,
      domLayout: null,
      tableData: null,
      selectedPromos: [],
      emptyList: true,
      selectedAgreementId: null,
      // Cell Renderer Components
      components: {
        CellRendererStatus,
      },
      // NOTE: ACTIONS:
      globalSearchTerm: "",
      flags: {
          selectedAll: [],
      },
    };
  },
  props: {
    editReq: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    status() {
      return event.node;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 10;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    onPageSizeChanged(newPageSize) {
      var value = document.getElementById("page-size").value;
      this.gridApi.paginationSetPageSize(Number(value));
    },

    onPaginationChanged() {
      if (this.gridApi) {
        (this.totalRows = this.gridApi.paginationGetRowCount()),
          (this.currentPageSize = this.gridApi.paginationGetPageSize());
      }
    },
    onRowSelected(event) {
      var getStatus = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data)
        .map((x) => x.status);
      getStatus.includes("rejected")
        ? (this.rejectedPromo = true)
        : (this.rejectedPromo = false);
      if (event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        this.selectedAgreementId = this.gridApi.getSelectedNodes()[0].id;
      } else {
        // Remove from selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    approveAllAgreements() {
      this.gridSelectAll();
      //approve all Agreements
      this.openConfirm();
    },
    openConfirm() {
      // Open confirm popup
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm",
        text: "Approving all Agreements. Are you sure?",
        acceptText: "Approve",
        cancelText: "Go Back",
        accept: () => {
          // this.stopPromoNotification(rowData)
          this.approveAgreements();
        },
        cancel: () => {
          this.gridApi.deselectAll();
        },
      });
    },
    approveAgreements() {
      this.openLoadingInDiv();
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      var selectedRowId = selectedRowData.map((x) => x.id);

      let url = this.editReq ? '/agreement/edit/approve' : '/agreement/request/approve';

      this.$axiosSecure.post(url, {
        id: selectedRowId,
      })
      .then((response) => {
        setTimeout(() => {
          this.refreshPage();
          // Hide loader
          this.hideLoadingInDiv();
          // Confimation notification
          this.$vs.dialog({
            color: "success",
            title: "Approved successfully",
            text: this.editReq ? "Selected Agreement/s have been approved. We will notify you via Flock when they're updated" : "Selected Agreement/s have been approved. We will notify you via Flock when they're created",
            acceptText: "Close",
            accept: () => {},
          });
        }, 500);
      })
      .catch((error) => {
        console.log("error", error);
        this.hideLoadingInDiv();
        this.$vs.dialog({
          color: "danger",
          title: "Something went wrong",
          text: "Please contact the server admin",
          acceptText: "Close",
          accept: () => {},
        });
      });
    },
    rejectAgreements() {
      this.addRejectCommentPopup = true;
      this.selectedAgreementForRejection = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data);
    },
    submitRejection() {
      this.addRejectCommentPopup = false;
      this.openLoadingInDiv();
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      var selectedRowId = selectedRowData.map((x) => x.id);

      let url = this.editReq ? '/agreement/edit/reject' : '/agreement/request/reject';

      this.$axiosSecure.post(url, {
        id: selectedRowId,
        rejected_comments: this.reject_comments,
        rejected_by: this.user_id,
      })
      .then((response) => {
        setTimeout(() => {
          this.refreshPage();
          this.resetComment();
          //Hide loader
          this.hideLoadingInDiv();
          // Confimation notification
          this.$vs.dialog({
            color: "danger",
            title: "Rejected",
            text: "Selected Agreement(s) have been rejected.",
            acceptText: "Close",
            accept: () => {
              // this.$router.push({ path: "/all-internal-promos" });
            },
          });
        }, 100);
      })
      .catch((error) => {
        console.log("error");
        this.hideLoadingInDiv();
        this.$vs.dialog({
          color: "danger",
          title: "Something went wrong",
          text: "Please contact the server admin",
          acceptText: "Close",
          accept: () => {},
        });
      });
    },
    resetComment() {
      this.reject_comments = "";
    },
    agreementBulkDeleteConfirm() {
      // Open confirm popup
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Confirm",
        text: "Delete Selected Agreement/s?",
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.deleteAgreement();
        },
      });
    },
    deleteAgreement() {
      this.openLoadingInDiv();
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      var selectedRowId = selectedRowData.map((x) => x.id);

      let url = this.editReq ? '/agreement/edit/delete' : '/agreement/request/delete'

      this.$axiosSecure.post(url, {
        id: selectedRowId,
      })
      .then((response) => {
        setTimeout(() => {
          this.refreshPage();
          //Hide loader
          this.hideLoadingInDiv();
          // Confimation notification
          this.$vs.dialog({
            color: "success",
            title: "Deleted successfully",
            text: "Selcted Agreement/s have been deleted.",
            acceptText: "Close",
            accept: () => {},
          });
        }, 100);
      })
      .catch((error) => {
        console.log("error");
        this.hideLoadingInDiv();
        //Error msg
        this.$vs.dialog({
          color: "danger",
          title: "Something went wrong",
          text: "Please contact the server admin",
          acceptText: "Close",
          accept: () => {},
        });
      });
    },
    populateTableData() {
      let self = this;

      let url = this.editReq ? '/agreement/edit/not-approved' : '/agreement/requests/not-approved';

      /* Get table data */
      this.$axiosSecure.get(url)
      .then((response) => {
        //Passing premium value as Yes or No
        for (var key in response.data) {
          if (response.data[key].unique_registrar_id) {
            //Client name
            response.data[key].partner_name =
              response.data[key].unique_registrar.name;
            //User name
            if (
              response.data[key].unique_registrar.unique_registrar_client_am
                .length &&
              response.data[key].unique_registrar
                .unique_registrar_client_am[0].user &&
              response.data[key].unique_registrar
                .unique_registrar_client_am[0].user.id
            ) {
              // console.log('partner_user', response.data[key].unique_registrar.user.name);
              response.data[key].partner_user =
                response.data[
                  key
                ].unique_registrar.unique_registrar_client_am[0].user.name;
            } else {
              response.data[key].partner_user = null;
            }
          } else {
            response.data[key].partner_name =
              response.data[key].new_reseller.name;
            if (
              response.data[key].new_reseller.new_reseller_client_am[0]
                .user &&
              response.data[key].new_reseller.new_reseller_client_am[0].user
                .id
            ) {
              response.data[key].partner_user =
                response.data[
                  key
                ].new_reseller.new_reseller_client_am[0].user.name;
            } else {
              response.data[key].partner_user = null;
            }
          }
          // console.log('partner_user', response.data[key].partner_user);
        }

        // NOTE: If user is on edit requests screen, format edit data
        if(this.editReq) {
          this.formatEditReqData(response.data);
        } else {
          this.tableData = response.data;
        }

        if (this.tableData.length > 0) {
          this.emptyList = false;
        }
      })
      .catch((error) => {
        // Error notification
        self.$vs.notify({
          color: "danger",
          title: "Something went wrong",
          text: "Please contact the server admin",
        });

        console.log(error);

        // Clear Listing Count
        this.$store.dispatch("clearListingCount");
      });
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("domain", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("domain", "left");
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    disableQueue() {
      this.rowClassRules = {
        "ag-row-disabled": 'data && (data.status == "new approved" || data.status == "queued" || data.status == "active")',
        "ag-row-red": 'data && (data.status == "rejected")',
      };
    },
    refreshPage() {
      // Reset filters
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    refreshPageWithFilters() {
      this.flags["selectedAll"] = false;
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    gridSelectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (
          !(
            node.data.status == "new approved" ||
            node.data.status == "rejected" ||
            node.data.status == "error"
          )
        ) {
          if (this.selectAll) {
            // Unselect the node
            node.setSelected(false);
          } else {
            // Select the node
            node.setSelected(true);
            var selectedRowId = node.data.id;
          }
        }
      });
    },
    formatEditReqData(data) {
      // NOTE: Format edit request data to use in the component
      data.forEach(el => {
        el['agreementEditReqData'] = {};
        el['agreementEditReqData']['agreement_detail'] = el.agreement_edit_detail;
        el['agreementEditReqData']['agreement_detail'].map(agtDetailEl => {
          agtDetailEl['agreement_cash_flow'] = agtDetailEl['agreement_edit_cash_flow']
        })
        el['agreementEditReqData']['agreement_id'] = el.agreement_new.agreement_request_id;
        el['agreementEditReqData']['append'] = el.append;
        el['agreementEditReqData']['approved_by'] = el.agreement_new.approved_by;
        el['agreementEditReqData']['approved_at'] = el.agreement_new.approved_at;
        el['agreementEditReqData']['conversion_rate'] = el.conversion_rate;
        el['agreementEditReqData']['currency'] = el.currency;
        el['agreementEditReqData']['currency_id'] = el.currency_id;
        el['agreementEditReqData']['dropbox_detail'] = el.agreement_new.dropbox_detail;
        el['agreementEditReqData']['filename'] = el.filename;
        el['agreementEditReqData']['id'] = el.id;
        el['agreementEditReqData']['new_reseller'] = el.new_reseller;
        el['agreementEditReqData']['new_reseller_id'] = el.new_reseller_id;
        el['agreementEditReqData']['partner_name'] = el.partner_name;
        el['agreementEditReqData']['partner_user'] = el.partner_user;
        el['agreementEditReqData']['provisional'] = el.provisional;
        el['agreementEditReqData']['start_date'] = el.start_date;
        el['agreementEditReqData']['end_date'] = el.end_date;
        el['agreementEditReqData']['status'] = el.status;
        el['agreementEditReqData']['type'] = el.type;
        el['agreementEditReqData']['unique_registrar'] = el.unique_registrar;
        el['agreementEditReqData']['unique_registrar_id'] = el.unique_registrar_id;
        el['agreementEditReqData']['updated_at'] = el.updated_at;
        el['agreementEditReqData']['user'] = el.user;
        el['agreementEditReqData']['original_filename'] = el.original_filename;
        el['agreementEditReqData']['temp_filename'] = el.temp_filename;
      })

      var tempData = data.map((x) => {
        return x.agreementEditReqData;
      });

      this.tableData = tempData;
    },
    deselectAllSelectedRows() {
      this.gridApi.deselectAll();

      this.flags["selectedAll"].fill(false);
    },
    onFilterChanged() {
      this.deselectAllSelectedRows();
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(
          document.getElementById("filter-text-box").value
      );
      this.deselectAllSelectedRows();
    },
    toggleSelectAll() {
      if (this.flags["selectedAll"]) {
        this.gridApi.deselectAll();
        this.flags["selectedAll"] = !this.flags["selectedAll"];
      } else {
        this.gridApi.selectAll();
        this.flags["selectedAll"] = !this.flags["selectedAll"];
      }
    },
  },
  beforeMount() {
    this.disableQueue();

    // Table Data AXIOS Call
    this.populateTableData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: "Agreement Name",
        field: "filename",
        filter: "agSetColumnFilter",
        checkboxSelection: params => params.data.status !== 'creation-pending',
        minWidth: 350,
        width: 350,
        pinned: "left",
        autoHeight: true,
        wrapText: true,
        cellClass: "cellCustomWrap",
        cellRendererFramework: "CellRendererAgreementFile",
        cellRendererParams: {
          source: this.editReq ? 'edit' : 'new'
        }
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agSetColumnFilter",
        minWidth: 150,
        cellClass: "v-center-cell"
      },
      {
        headerName: "Partner Name",
        field: "partner_name",
        filter: "agSetColumnFilter",
        minWidth: 150,
        cellClass: "v-center-cell"
      },
      {
        headerName: "AM",
        field: "partner_user",
        filter: "agSetColumnFilter",
        minWidth: 150,
        cellRenderer: (data) => {
          if (data.data.partner_user) {
            return data.data.partner_user;
          } else {
            return "-";
          }
        },
        cellClass: "v-center-cell"
      },
      {
        headerName: "Start Date",
        field: "start_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
        cellClass: "v-center-cell"
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
        cellClass: "v-center-cell"
      },
      {
        headerName: "Total Amount",
        field: "",
        filter: "agSetColumnFilter",
        minWidth: 150,
        cellRenderer: (data) => {
            if (data.data.agreement_detail && data.data.agreement_detail.length) {
                return decodeURI(data.data.currency.sign) + " " + 
                Number(parseFloat(data.data.agreement_detail[0].total_amount).toFixed(2)).toLocaleString('en', {
                    minimumFractionDigits: 2
                });
            } else {
                return 0;
            }
        },
        valueGetter: (data) => {
            if (data.data.agreement_detail && data.data.agreement_detail.length) {
                return decodeURI(data.data.currency.sign) + " " + 
                Number(parseFloat(data.data.agreement_detail[0].total_amount).toFixed(2)).toLocaleString('en', {
                    minimumFractionDigits: 2
                });
            } else {
                return 0;
            }
        },
        cellClass: "v-center-cell"
      },
      {
          headerName: "Total Converted Amount",
          field: "",
          filter: "agSetColumnFilter",
          minWidth: 150,
          cellRenderer: (data) => {
              if (data.data.agreement_detail && data.data.agreement_detail.length) {
                  return "$ " + 
                  Number(parseFloat(data.data.agreement_detail[0].total_converted_amount).toFixed(2)).toLocaleString('en', {
                      minimumFractionDigits: 2
                  });
              } else {
                  return 0;
              }
          },
          valueGetter: (data) => {
              if (data.data.agreement_detail && data.data.agreement_detail.length) {
                  return "$ " +
                  Number(parseFloat(data.data.agreement_detail[0].total_converted_amount).toFixed(2)).toLocaleString('en', {
                      minimumFractionDigits: 2
                  });
              } else {
                  return 0;
              }
          },
          cellClass: "v-center-cell"
      },
      {
        headerName: "Status",
        field: "status",
        filter: "agSetColumnFilter",
        cellRendererFramework: "CellRendererStatus",
        minWidth: 150,
        cellClass: "v-center-cell"
      },
      {
        headerName: "Upload date",
        field: "updated_at",
        filter: "agSetColumnFilter",
        minWidth: 150,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
        cellClass: "v-center-cell"
      },
      {
        headerName: "Actions",
        field: "actions",
        pinned: "right",
        cellRendererFramework: "CellRendererViewAndEditActions",
        minWidth: 150,
        cellClass: "v-center-cell"
      },
    ]),
      // Set Grid sidebar
      (this.sideBar = {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
      });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    //agigrid loader
    this.gridApi.showLoadingOverlay();

    // Resize to fit columns
    this.sizeColumnsToFit();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    this.$root.$on("tableRefresh", () => {
      this.refreshPage();
    });
  },
  destroyed() {
    // Clear Listing Count
    this.$store.dispatch("clearListingCount");
    this.$root.$off("tableRefresh");
  },
};
</script>

<style lang="scss">
.ag-selection-checkbox {
  display: flex;
  align-items: center;
  height: 36px;
}

.ag-row-disabled,
.ag-checkbox-disabled .ag-group-checkbox {
  pointer-events: none;
}

.ag-row-disabled .ag-group-checkbox,
.ag-checkbox-disabled .ag-group-checkbox {
  opacity: 0.3;
}

.ag-row-level-1 .ag-group-value,
.text-capitalize input {
  text-transform: capitalize;
}

//Hide grouping arrow
.ag-group-expanded,
.ag-group-contracted {
  display: none !important;
}

.ag-group-checkbox {
  margin-left: 0 !important;
}

.text-capitalize {
  text-transform: capitalize;
}

.vs-tabs--content {
  padding: 23px 0px !important;
}
</style>
